import React, { useRef } from 'react'
import useOutsideAlerter from '../../hooks/useOutsideAlerter'

export const OutsideAlerter = ({ children, onOutsideClick, testid }) => {
  const wrapperRef = useRef(null)
  useOutsideAlerter(wrapperRef, onOutsideClick)

  return <div ref={wrapperRef} data-testid={testid}>{children}</div>
}